<script setup>
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '@/modules/auth/stores/auth.store'

const { t } = useI18n()
const authStore = useAuthStore()

const settings = ref(null)
const settingsItem = {
  name: 'core.menu.general.settings',
  icon: 'pi pi-cog',
  type: 'core',
}

const isAppAdmin = computed(() =>
  authStore.userRoles.includes('app-administrator'),
)

const isClientAdmin = computed(() =>
  authStore.userRoles.includes('client-administrator'),
)

const filteredAdminMenu = computed(() => {
  const menu = []

  if (isAppAdmin.value) {
    menu.push({
      name: t('core.menu.general.platform-management'),
      route: '/platform-admin',
      children: [
        {
          name: t('core.menu.general.system-permissions'),
          route: '/platform-admin/system-permissions',
        },
      ],
    })
  }

  if (isClientAdmin.value) {
    menu.push({
      name: t('core.menu.general.tenant-admin'),
      route: `/tenant-admin/${authStore.tenantData?.economicGroup}`,
      children: [
        //   {
        //     name: t('core.menu.general.general-settings'),
        //     route: '/tenant-admin/general-settings',
        //   },
        //   {
        //     name: t('core.menu.general.security-permissions'),
        //     route: '/tenant-admin/security-permissions',
        //   },
        //   {
        //     name: t('core.menu.general.master-data-management'),
        //     route: '/tenant-admin/tenant-master-data-management',
        //   },
      ],
    })
  }

  return menu
})

function displayContextMenu(event) {
  settings.value?.toggle(event)
}

function handleMenuClick() {
  settings.value?.hide()
}

const handleScroll = () => settings.value?.hide()

onMounted(() => {
  window.addEventListener('scroll', handleScroll, { passive: true })
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})

const hasMenuAccess = computed(() => isAppAdmin.value || isClientAdmin.value)
</script>

<template>
  <div v-if="hasMenuAccess">
    <dss-menu-item
      :item="{
        icon: settingsItem.icon,
        name: settingsItem.name,
        route: settingsItem.route,
      }"
      @click="displayContextMenu"
    />

    <Popover
      ref="settings"
      pt:root="drop-shadow before:hidden after:hidden w-60 mx-6 bg-white -mt-2 rounded-2xl rounded-bl-none"
    >
      <nav class="flex flex-col w-full">
        <div
          v-for="(section, index) in filteredAdminMenu"
          :key="index"
          class="flex flex-col w-full"
        >
          <h2 class="text-sm font-bold">
            <router-link
              :to="section.route"
              @click="handleMenuClick"
            >
              {{ section.name }}
            </router-link>
          </h2>

          <ul
            v-if="section.children.length > 0"
            class="flex flex-col space-y-2 mt-2"
          >
            <li
              v-for="(item, itemIndex) in section.children"
              :key="itemIndex"
            >
              <router-link
                :to="item.route"
                class="block indent-3 text-sm text-surface-800 hover:text-surface-500"
                @click="handleMenuClick"
              >
                {{ item.name }}
              </router-link>
            </li>
          </ul>

          <div
            v-if="index < filteredAdminMenu.length - 1"
            class="py-4"
          >
            <div class="bg-surface-200 h-px" />
          </div>
        </div>
      </nav>
    </Popover>
  </div>
</template>

<style scoped></style>
